export const MyCarzelleSectionHeader = ({title, number, className}) => {
    return (
        <div className={`capitalize mt-8 mb-4 rounded-2xl bg-gray-200 flex items-center justify-between pl-4 pr-4 py-2 max-w-max ml-[-12px] font-bold text-sm ${className}`}>
            <div>{title}</div>
            <div className="rounded-full w-7 h-7 p-2 bg-gray-500 flex items-center justify-center text-white ml-2">{number}</div>
        </div>
    )
}